// src/services/membershipApi.js
import api from './api';

const membershipApi = {
  // Get current user's membership information
  getCurrentMembership: () => api.get('/api/membership/current'),

  // Get credit balance
  getCreditBalance: () => api.get('/api/membership/credit-balance'),

  // Get membership configuration (tiers, features, etc.)
  getMembershipConfig: () => api.get('/api/membership/config'),

  // Start a Stripe Checkout Session to purchase a paid subscription
  // tier: 'gold' | 'platinum'
  // interval: 'monthly' | 'quarterly'
  createCheckoutSession: (tier, interval) =>
    api.post('/api/membership/create-checkout-session', { tier, interval }),

  // Cancel the active subscription at the end of the current billing period
  cancelSubscription: () => api.post('/api/membership/cancel-subscription'),

  // Undo a pending cancellation (only valid before period end)
  resumeSubscription: () => api.post('/api/membership/resume-subscription'),

  // Membership tier history (transitions)
  getMembershipHistory: (limit = 20) =>
    api.get('/api/membership/history', { params: { limit } }),

  // Paid subscription invoice history
  getPaymentHistory: (limit = 50) =>
    api.get('/api/membership/payment-history', { params: { limit } }),

  // Purchase additional credits (legacy)
  purchaseCredits: (amount) => api.post('/api/membership/purchase-credits', { amount }),

  // Check service credit cost
  getServiceCost: (serviceType) => api.get(`/api/membership/service-cost/${serviceType}`),
};

export default membershipApi;
